module.exports = __webpack_public_path__ + "static/Slim events require more communication.drawio-e1024eef1ba2206a951d602ea2bd2669.png";